/* eslint-disable no-else-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-shadow */
import React, { useEffect, useRef, useState } from 'react'
import {
  Chip,
  TextField,
  Typography,
  Checkbox,
  makeStyles,
  Box,
  Button,
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

export const useStyles = makeStyles(() => ({
  root: {
    margin: '15px',
    '& .MuiAutocomplete-tag': {
      display: 'none',
    },
  },
  container: {
    width: '100%',
    position: 'relative',
    '&:hover button': {
      display: 'flex',
    },
  },
  button: {
    position: 'absolute',
    padding: '6px',
    zIndex: 2,
    top: '4px',
    display: 'none',
    right: 0,
    background: '#C9CCD1',
    color: '#5A5A5A',
    fontWeight: 'bold',
    cursor: 'pointer',
    borderRadius: '4px',
  },
  valueRendered: {
    position: 'absolute',
    height: '52px',
    top: '-44px',
    left: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
  },
  buttonSelectAll: {
    position: 'absolute',
    height: '26px',
    top: '-32px',
    right: '4px',
    fontSize: '12px',
    backgroundColor: '#35465c',
    color: 'white',
    '&:hover': {
      backgroundColor: '#35465c',
      color: 'white',
    },
  },
  containerChipsScroll: {
    overflowY: 'scroll',
    maxHeight: '100px',
    display: 'flex',
    flexWrap: 'wrap',
    width: '600px'
  }
}))

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const MultiSelect = ({ label, onChange, options, values, change }) => {
  const [showScroll, setShowScroll] = useState(false)

  const items = options.sort()
    .map((el) => ({ label: el, value: el, categorie: label }))
    .filter((el) => el.value !== '' && el.value !== '---VACIO---')

  const valuesFormated = values.sort()
    .map((el) => ({ label: el, value: el, categorie: label }))
    .filter((el) => el.value !== '' && el.value !== '---VACIO---')

  const optionsIncludes = items.filter((el) => values.includes(el.value))
  const classes = useStyles()
  const [selectedOptions, setSelectedOptions] = useState(optionsIncludes)
  const [optionsShow, setOptionsShow] = useState(items)

  useEffect(() => {
    change === true && setOptionsShow(valuesFormated)
    change === true && setSelectedOptions(valuesFormated)
    selectedOptions.length === 0 && setSelectedOptions(valuesFormated)
  }, [values])

  const handleToggleOption = (selectedOptions) => {
    setSelectedOptions(selectedOptions)
  }

  const getOptionLabel = (option) => `${option.label}`

  const handleSelectOne = (e, option) => {
    e.stopPropagation()
    handleToggleOption([option])
    onChange([option.value])
  }

  const handleChange = (event, selectedOptions, reason) => {
    if (reason === "select-option" || reason === "remove-option") {
      handleToggleOption && handleToggleOption(selectedOptions)
      const arraySelected = selectedOptions.map((el) => el.value)
      return onChange(arraySelected)
    }
    if (reason == 'clear') {
      setSelectedOptions(valuesFormated)
    }
  }

  const handleSelectAll = () => {
    setSelectedOptions(optionsShow)
    const included = optionsShow.map(el => el.value)
    return onChange(included)
  }

  const optionRenderer = (option, { selected }) => (
    <Box className={classes.container}>
      <Checkbox
        color="primary"
        icon={icon}
        checkedIcon={checkedIcon}
        checked={selected}
        style={{ marginRight: 8 }}
      />
      {getOptionLabel(option)}
      <button
        type="button"
        className={classes.button}
        onClick={(e) => handleSelectOne(e, option)}
      >
        SOLAMENTE
      </button>
    </Box>
  )
  const inputRenderer = (params) => (
    <div style={{ position: 'relative' }}>
      <TextField {...params} variant="outlined" />
      <span className={classes.valueRendered}>
        {values.length > 0 ? `${label} ( ${selectedOptions.length} )` : ''}
      </span>
      <Button
        color="primary"
        onClick={handleSelectAll}
        className={classes.buttonSelectAll}
      >
        Seleccionar todas
      </Button>
    </div>
  )

  const getOptionSelected = (option, anotherOption) =>
    option.value === anotherOption.value
  const ref = useRef(label)
  return (
    <Autocomplete
      multiple
      freeSolo
      ref={ref}
      limitTags={1}
      options={optionsShow}
      value={selectedOptions}
      id={label}
      disableCloseOnSelect
      className={classes.root}
      ListboxProps={{ style: { maxHeight: 200, overflow: 'auto' } }}
      ChipProps={{ style: { maxHeight: 200, overflow: 'auto' } }}
      disableClearable
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      renderTags={(value, getTagProps) => {
        if(showScroll) {
          return (
            <div className={classes.containerChipsScroll}>
              {
                value.map((option, index) => (
                  <Chip
                    label={<Typography>{option.value}</Typography>}
                    {...getTagProps({ index })}
                    style={{
                      backgroundColor: 'white',
                      display: 'flex',
                      margin: '0 6px 0 0',
                    }}
                  />
                ))
              }
            </div>
          )
        } else {
          return (
            value.map((option, index) => (
              <Chip
                label={<Typography>{option.value}</Typography>}
                {...getTagProps({ index })}
                style={{
                  backgroundColor: 'white',
                  display: 'flex',
                  margin: '0 6px 0 0',
                }}
              />
            ))
          )
        }
      }}
      onChange={handleChange}
      onFocus={() => setShowScroll(true)}
      onBlur={() => setShowScroll(false)}
      renderOption={optionRenderer}
      renderInput={inputRenderer}
    />
  )
}

export default MultiSelect
